export var InsightVariants;
(function (InsightVariants) {
    InsightVariants["default"] = "default";
    InsightVariants["highlight"] = "highlight";
})(InsightVariants || (InsightVariants = {}));
export var InsightWeights;
(function (InsightWeights) {
    InsightWeights["regular"] = "regular";
    InsightWeights["bold"] = "bold";
})(InsightWeights || (InsightWeights = {}));
//# sourceMappingURL=constants.js.map